var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { InputEventType } from "./InputManager.js";
class KeyboardListener {
  constructor(inputManager) {
    __publicField(this, "registry", {});
    __publicField(this, "handleKeyDown", (e) => {
      this.handleKey(e, "keydown");
    });
    __publicField(this, "handleKeyUp", (e) => {
      this.handleKey(e, "keyup");
    });
    this.inputManager = inputManager;
    const interactionDiv = document.body;
    interactionDiv.addEventListener("keydown", this.handleKeyDown);
    interactionDiv.addEventListener("keyup", this.handleKeyUp);
  }
  init(keys) {
    if (!keys) {
      this.on("keydown-*", (key, event2) => {
        this.inputManager.dispatchEvent(key, true, InputEventType.KEYBOARD, 0, event2);
      });
      this.on("keyup-*", (key) => {
        this.inputManager.dispatchEvent(key, false, InputEventType.KEYBOARD, 0, event);
      });
    } else {
      for (const key of keys) {
        this.on(
          `keydown-${key}`,
          (_key, event2) => this.inputManager.dispatchEvent(key, true, InputEventType.KEYBOARD, 0, event2)
        );
        this.on(
          `keyup-${key}`,
          (_key, event2) => this.inputManager.dispatchEvent(key, false, InputEventType.KEYBOARD, 0, event2)
        );
      }
    }
  }
  destroy() {
    const interactionDiv = document.body;
    interactionDiv.removeEventListener("keydown", this.handleKeyDown);
    interactionDiv.removeEventListener("keyup", this.handleKeyUp);
    this.registry = {};
  }
  on(key, callback) {
    if (!this.registry[key]) {
      this.registry[key.toLowerCase()] = [];
    }
    this.registry[key.toLowerCase()].push(callback);
  }
  handleKey(e, prefix) {
    let key = e.key.toLowerCase();
    if (e.code) {
      let convertedCode = e.code.toLowerCase().replace("bracketleft", "[").replace("bracketright", "]").replace("backquote", "`").replace("backslash", "\\").replace("comma", ",").replace("period", ".").replace("slash", "/").replace("semicolon", ";").replace("quote", "'").replace("minus", "-").replace("equal", "=").replace(/key|digit|right|left/g, "");
      if (convertedCode.length === 1) {
        key = convertedCode;
      }
    }
    if (key.startsWith("arrow")) {
      key = key.substring(5);
    } else if (key === " ") {
      key = "space";
    }
    if (this.registry[`${prefix}-${key}`]) {
      const callbacks = this.registry[`${prefix}-${key}`];
      for (let i = 0; i < callbacks.length; ++i) {
        callbacks[i](key, e);
      }
    }
    if (this.registry[`${prefix}-*`]) {
      const callbacks = this.registry[`${prefix}-*`];
      for (let i = 0; i < callbacks.length; ++i) {
        callbacks[i](key, e);
      }
    }
  }
}
export {
  KeyboardListener
};
//# sourceMappingURL=KeyboardListener.js.map
